import { AdsTableProvider } from './hooks/useAdsTable'
import Table from './Table'

const AdsTable = ({
  campaignAdType,
  campaignStatus,
  strategy
}: Pick<
  AdsTableProviderProps,
  'campaignAdType' | 'campaignStatus' | 'strategy'
>) => (
  <AdsTableProvider
    campaignAdType={campaignAdType}
    campaignStatus={campaignStatus}
    strategy={strategy}
  >
    <Table />
  </AdsTableProvider>
)

export default AdsTable
